export const Link = () => ({
  styleOverrides: {
    root: {
      fontSize: 14,
      fontWeight: 500,
      textDecoration: 'none'
    }
  }
});